import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";

export interface GoodsOrderCount {
    product_idx: number;
    order_count: number;
    last_order_date: string | null;
}

/*
// 상품에 연결된 주문 건수.
//
// 주문은 상품코드를 자기 레코드에 갖지 않고 상품 정보를 조인해 보여준다. 그래서 상품을
// 지우면 그 상품으로 나간 과거 주문의 상품코드까지 같이 사라진다. 삭제 확인 팝업을 띄우기
// 직전에 이 영향을 알려야 하므로, useQuery 가 아니라 호출 시점에 부르는 함수로 둔다.
*/
export const fetchGoodsOrderCount = async (accessToken: string | null, productIdx: number[]): Promise<GoodsOrderCount[]> => {
    if (productIdx.length === 0) return [];

    const params = new URLSearchParams();
    productIdx.forEach(idx => params.append("product_idx", idx.toString()));

    const response = await axios.get(`${enum_api_uri.get_product_order_count}?${params.toString()}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });

    return response.data.data;
};
